import { get, getUser as tychoGetUser } from '../lib/tycho';

export const getUser = () => dispatch => {
  return tychoGetUser().then(user => dispatch({type: 'USER_RECEIVE', payload: user}));
};

export const getFolderPermissionForUser = ({
  invite_id,
  invitee_user_id,
  folder_id
}) => dispatch => {
  return get(`/v1/invites/${invite_id}/permissions`)
    .then(res => res.json())
    .then(permissions => dispatch({type: 'FOLDER_PERMISSIONS_RECEIVE', payload: {
      user_id: invitee_user_id,
      folder_id,
      permissions
    }}));
};
